import './FloatingIcons.css'

const drawings = {
    flower: (
        <>
            <path d="M27 23C15 12 23 3 31 13C37-1 50 8 40 22C57 18 64 31 46 36C61 47 48 59 37 46C34 64 18 58 22 43C5 48 3 32 21 29C9 23 15 11 27 23Z" />
            <circle cx="33" cy="31" r="10" className="floating-accent__center" />
            <g className="floating-accent__face" stroke="none">
                <circle cx="30" cy="30" r="1" />
                <circle cx="36" cy="30" r="1" />
            </g>
            <path d="M30 34q3 3 6 0" fill="none" />
        </>
    ),
    star: (
        <>
            <path d="m31 9 7 14 16 3-12 11 2 16-13-8-14 8 3-16L8 26l16-3Z" />
            <path d="m49 8 2 5 5 2-5 2-2 5-2-5-5-2 5-2Z" className="floating-accent__center" />
            <path d="m9 48 3 3m-7 1 3 3" fill="none" />
        </>
    ),
    leaf: (
        <>
            <path d="M30 55C22 42 42 27 33 10" fill="none" />
            <path d="M32 40C14 42 11 29 15 26C27 25 31 33 32 40ZM33 29C47 33 56 22 51 17C40 16 35 22 33 29ZM34 17C25 17 20 8 25 5C32 6 36 11 34 17Z" />
            <path d="m20 31 11 9m4-12 12-7" fill="none" opacity=".5" />
        </>
    ),
    paint: (
        <>
            <path d="M7 20C7 8 27 7 26 21C26 32 8 32 7 20Z" stroke="none" />
            <path d="M32 38C30 25 49 23 51 36C54 48 35 52 32 38Z" className="floating-accent__center" stroke="none" />
            <circle cx="49" cy="13" r="5" className="floating-accent__sage" stroke="none" />
            <path d="M17 45C24 43 28 50 23 55C17 59 12 50 17 45Z" className="floating-accent__sage" stroke="none" />
        </>
    ),
    plane: (
        <>
            <path d="M6 27 57 8 43 54 31 40 21 49 24 34Z" />
            <path d="M24 34 57 8 31 40m-10 9 3-15" fill="none" />
            <path d="M7 44c5 0 7 4 11 4m-9 5c4 0 6 2 8 4" fill="none" strokeDasharray="2 3" />
        </>
    ),
    bow: (
        <>
            <path d="M30 29C21 14 8 17 9 28c1 9 13 10 21 6M34 29c9-15 22-12 21-1-1 9-13 10-21 6" />
            <path d="m29 36-9 17 11-5 3 8 3-20m-3 0 10 17-11-5-3 8" className="floating-accent__center" />
            <circle cx="32" cy="32" r="5" className="floating-accent__center" />
        </>
    ),
    yarn: (
        <>
            <circle cx="31" cy="28" r="18" />
            <path d="M18 18c8 1 16 8 24 20M13 30c9-8 20-11 34-7M21 43c3-10 12-21 26-25" fill="none" />
            <path d="M40 43c8 2 8 8 2 10-5 2-10-4-5-7 4-2 6 2 3 4m2 3c5 4 9 4 14 0" fill="none" />
        </>
    ),
    mug: (
        <>
            <path d="M13 25h34l-3 23c-1 5-5 8-10 8H25c-5 0-9-3-10-8Z" />
            <path d="M47 29h4c10 0 10 16-5 17M10 57h42M22 8c-5 6 5 7 0 13m11-15c-5 6 5 7 0 13m11-11c-5 6 5 7 0 13" fill="none" />
            <path d="M25 36c3-5 7-2 8 0 2-3 7-4 9 0-1 5-8 9-9 10-2-2-7-5-8-10Z" className="floating-accent__center" />
        </>
    ),
    orbit: (
        <>
            <circle cx="31" cy="31" r="17" />
            <path d="M10 43c8 5 23 4 34-2 12-6 18-15 13-20-2-2-6-2-10-1M13 24c-8 6-11 12-8 16" fill="none" />
            <circle cx="26" cy="24" r="3" className="floating-accent__center" stroke="none" />
            <path d="m51 8 2 4 4 2-4 2-2 4-2-4-4-2 4-2Z" className="floating-accent__center" />
        </>
    ),
    envelope: (
        <>
            <path d="M9 19h46v32H9z" />
            <path d="m10 20 22 18 22-18M10 50l16-15m28 15L38 35" fill="none" />
            <path d="M28 35c-5-5-1-10 4-6 5-4 9 1 4 6l-4 4Z" className="floating-accent__center" />
            <path d="m50 8 1 3 3 1-3 1-1 3-1-3-3-1 3-1Z" className="floating-accent__center" />
        </>
    ),
}

const arrangements = {
    hero: ['flower', 'plane', 'star', 'bow', 'leaf'],
    projects: ['orbit', 'star', 'plane', 'paint', 'flower'],
    about: ['yarn', 'mug', 'leaf', 'bow', 'paint'],
    contact: ['envelope', 'flower', 'star', 'bow', 'plane'],
}

const FloatingIcons = ({ variant = 'hero' }) => (
    <div
        className={`floating-accents floating-accents--${variant}`}
        aria-hidden="true"
    >
        {(arrangements[variant] || arrangements.hero).map((kind, index) => (
            <span
                key={`${kind}-${index}`}
                className={`floating-accent floating-accent--${kind} floating-accent--spot-${index + 1}`}
            >
                <svg
                    viewBox="0 0 64 64"
                    fill="var(--float-fill)"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    focusable="false"
                >
                    {drawings[kind]}
                </svg>
            </span>
        ))}
    </div>
)

export default FloatingIcons
